import { translateLabel } from "@/i18n/messages";
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function OperatorRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center bg-[#121214] text-sm font-semibold text-zinc-400">{translateLabel("Checking operator access…")}</div>;
  }
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}
